import styled from 'styled-components';
import { Subtitle } from 'components/Typography';
import DefaultBrandSelect from 'components/Form/BrandSelect';
import addAlpha from 'utils/addAlpha';
import DefaultSpinner from 'components/Spinner';
import StickyHeader from 'components/StickyHeader';
import DefaultSimpleLoader from 'components/Loaders/SimpleLoader';

export const Container = styled.div`
  margin-bottom: 3rem;
`;

export const Header = styled(StickyHeader)``;

export const DateCaption = styled(Subtitle)`
  font-weight: 600;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  margin-right: 1.5rem;
`;

export const SearchInputContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const BrandSelect = styled(DefaultBrandSelect)`
  margin-left: auto;
  margin-right: 4.5rem;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Spinner = styled(DefaultSpinner)``;

export const Loader = styled(DefaultSimpleLoader)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => addAlpha(theme.colors.gray6, 0.6)};
  min-height: 100%;
  z-index: 10;
`;
